import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Impuesto } from './Impuesto';
import { environment } from '../environments/environment';
import { ImpuestoValor } from './impuestoValor';





@Injectable({
  providedIn: 'root'
})
export class ImpuestoService {

  constructor(private http: HttpClient) { }

 
  getImpuestos() {  
    
    return this.http.get<Impuesto[]>(environment.apiUrl+"/listarImpuesto/");  
  }  


  getImpuestosCodigo(codigo,emisor){
  
    return this.http.get<ImpuestoValor[]>(environment.apiUrl+"/listarImpuestoValor/?codigo="+ codigo+"&idEmisor="+emisor);  
  
    

  }

}
